import { createContext } from 'react';

interface LanguageContextType {
  currentLanguage: string;
  changeLanguage: (language: string) => void;
  availableLanguages: Array<{ code: string; name: string; nativeName: string }>;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
